import angular from 'angular';

(function() {
    'use strict';
    angular.module('app.core').factory('ContainersFilter', ContainersFilterData);

    ContainersFilterData.$inject = [];

    /* @ngInject */
    function ContainersFilterData() {
        Container.prototype = {
            build: build,
            buildEmpty: buildEmpty,
            setPrincipalEid: setPrincipalEid,
            getPrincipalEid: getPrincipalEid,
            setCompanyId: setCompanyId,
            getCompanyId: getCompanyId
        };

        function Container(containersFilterData) {
            if (!containersFilterData) {
                this.buildEmpty();
            } else {
                this.build(containersFilterData);
            }
        }

        return Container;

        /////////////////////

        function buildEmpty() {
            this.principalEid = null;
            this.companyId = null;
            this.containerStatus = null;
            this.language = null;
            this.companyName = null;
            this.containerType = null;
            this.ladProviderId = null;
            this.dematMode = null;
            this.traitementType = null;
            this.containerMode = null;
            this.principalId = null;
            this.containerId = null;
            this.containerName = null;
            this.perimeterCode = null;
        }

        function build(containersFilterData) {
            this.principalEid = containersFilterData.principalEid || null;
            this.companyId = containersFilterData.companyId || null;
            this.containerStatus = containersFilterData.containerStatus || null;
            this.language = containersFilterData.language || null;
            this.companyName = containersFilterData.companyName || null;
            this.containerType = containersFilterData.containerType || null;
            this.ladProviderId = containersFilterData.ladProviderId || null;
            this.dematMode = containersFilterData.dematMode || null;
            this.traitementType = containersFilterData.traitementType || null;
            this.containerMode = containersFilterData.containerMode || null;
            this.principalId = containersFilterData.principalId || null;
            this.containerId = containersFilterData.containerId || null;
            this.containerName = containersFilterData.containerName || null;
            this.perimeterCode = containersFilterData.perimeterCode || null;
        }
    }

    function setPrincipalEid(principalEid) {
        this.principalEid = principalEid;
    }

    function getPrincipalEid() {
        return this.principalEid;
    }

    function setCompanyId(companyId) {
        this.companyId = companyId;
    }

    function getCompanyId() {
        return this.companyId;
    }
})();
